import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT_INFO } from "../data/site";
import { scrollToTop } from "../lib/lenis";
import { useLang } from "../i18n/LanguageContext";

const LINKS = [
  { to: "/servizi", id: "servizi" },
  { to: "/lavori", id: "lavori" },
  { to: "/recensioni", id: "recensioni" },
  { to: "/chi-siamo", id: "chiSiamo" },
  { to: "/contatti", id: "contatti" },
];

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="border-t border-line bg-surface2/60" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="flex flex-col justify-between gap-12 md:flex-row">
          <div className="max-w-sm">
            <Logo className="h-24" />
            <p className="mt-6 text-sm leading-relaxed text-slate-500">{t.footer.tagline}</p>
          </div>

          <div className="grid grid-cols-2 gap-12 sm:grid-cols-3">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-700">{t.footer.nav}</p>
              <ul className="mt-5 space-y-3">
                {LINKS.map((item) => (
                  <li key={item.id}>
                    <Link to={item.to} className="text-sm text-slate-500 transition-colors hover:text-brand" data-testid={`footer-link-${item.id.toLowerCase()}`}>
                      {t.nav[item.id]}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-700">{t.footer.contacts}</p>
              <ul className="mt-5 space-y-3 text-sm text-slate-500">
                <li>{CONTACT_INFO.address}</li>
                <li>{CONTACT_INFO.phone}</li>
                <li>{CONTACT_INFO.email}</li>
              </ul>
            </div>
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-700">{t.footer.company}</p>
              <ul className="mt-5 space-y-3 text-sm text-slate-500">
                <li>TecnoEdil.EA S.R.L.S</li>
                <li>{CONTACT_INFO.piva}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 flex items-center justify-between border-t border-line pt-8">
          <p className="text-xs text-slate-400">© {new Date().getFullYear()} TecnoEdil.EA S.R.L.S — {t.footer.rights}</p>
          <button
            onClick={scrollToTop}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-line bg-white text-slate-500 transition-colors hover:border-brand hover:bg-brand hover:text-white"
            aria-label={t.footer.backTop}
            data-testid="back-to-top-button"
          >
            <ArrowUp size={17} />
          </button>
        </div>
      </div>
    </footer>
  );
}
